import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const F = "'Inter', system-ui, sans-serif";

export default function LoginForm() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(password);
    setLoading(false);
    if (!result.ok) {
      setError(result.error || 'Anmeldung fehlgeschlagen.');
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h2 style={styles.heading}>Admin-Anmeldung</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Passwort</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={styles.input}
            autoFocus
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrapper: { minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', backgroundColor: '#f8f9fa' },
  card: { backgroundColor: 'white', borderRadius: '12px', padding: '2.5rem', width: '100%', maxWidth: '360px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid #e5e7eb' },
  heading: { textAlign: 'center', color: '#111827', fontFamily: F, fontSize: '1.2rem', fontWeight: '700', marginBottom: '1.5rem' },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  label: { fontWeight: '600', fontSize: '0.85rem', color: '#374151', fontFamily: F },
  input: { padding: '0.7rem 0.9rem', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.95rem', fontFamily: F },
  error: { color: '#dc3545', fontSize: '0.85rem', margin: 0, fontFamily: F },
  button: { padding: '0.85rem', backgroundColor: '#1e8449', color: 'white', border: 'none', borderRadius: '8px', fontSize: '0.95rem', fontWeight: '700', cursor: 'pointer', fontFamily: F },
};
